export enum UserRole {
  admin = 'admin',
  chain = 'chain',
  place = 'place',
}